module.exports = __webpack_public_path__ + "img/acmanage.2a5a330f.svg";